import React from 'react';
import { styled } from '@mui/material/styles';
import { useSession } from 'next-auth/react';
import { isCustomer } from 'services/subscriptionUtils';
import useMyLearning from '../../hooks/useMyLearning';

const Container = styled('div')(({ $isCustomer }) => ({
  display: $isCustomer ? 'flex' : 'none',
  position: 'relative',
  flexDirection: 'row',
  borderBottom: '1px solid #ccc',
  '@media screen and (min-width: 992px)': {
    justifyContent: 'flex-start',
    alignItems: 'space-between',
    padding: '0 13%',
  },
  '@media screen and (max-width: 991px)': {
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '0 3%',
  },
  '@media screen and (max-width: 400px)': {
    alignItems: 'flex-start',
  },
}));

const ImageContainer = styled('div')(({ $backgroundImageUrl }) => ({
  '@media screen and (min-width: 992px)': {
    width: '50%',
    backgroundImage: `url('${$backgroundImageUrl}')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '335px',
    backgroundPosition: 'right 0 top 0%',
  },
  '@media screen and (max-width: 991px)': {
    display: 'none',
  },
  '@media screen and (max-width: 400px)': {
    display: 'none',
  },
}));

const TextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-start',
  minHeight: 'inherit',
  '@media screen and (min-width: 900px)': {
    width: '90%',
    height: '220px',
    paddingRight: '10px',
  },
  '@media screen and (max-width: 899px)': {
    width: '100%',
  },
});

const HeroTitle = styled('div')({
  color: '#000',
  fontWeight: 700,
  textTransform: 'uppercase',
  '@media screen and (min-width: 900px)': {
    fontSize: '2.5rem',
    lineHeight: '3.375rem',
  },
  '@media screen and (max-width: 899px)': {
    fontSize: '2rem',
    lineHeight: '2.725rem',
  },
});

const BrandText = styled('div')(({ $brandColor }) => ({
  color: '#fff',
  backgroundColor: $brandColor,
  fontWeight: 600,
  padding: '2px 20px',
  '@media screen and (min-width: 900px)': {
    fontSize: '1rem',
    lineHeight: '1.75rem',
  },
  '@media screen and (max-width: 899px)': {
    fontSize: '1rem',
    lineHeight: '1.25rem',
  },
}));

const _HeroSeparator = styled('div')(({ theme }) => ({
  color: theme.palette.common.white,
  fontWeight: 200,
  fontSize: '1.75rem',
  lineHeight: '1.85rem',
  margin: '0 30px',
}));

const SubscriptionTitleWithIcon = ({ module }) => {
  const { fields } = module;
  const { data: session } = useSession();

  const isMyLearning = useMyLearning();

  if (!isMyLearning) {
    return;
  }

  return (
    <React.Fragment>
      <Container $isCustomer={isCustomer(session?.user)}>
        <TextContainer>
          <BrandText $brandColor={fields.brandColor}>{fields.brandText}</BrandText>
          <HeroTitle>{fields.title}</HeroTitle>
        </TextContainer>
        <ImageContainer $backgroundImageUrl={fields.titleIcon.url}></ImageContainer>
      </Container>
    </React.Fragment>
  );
};
export default SubscriptionTitleWithIcon;
